import { useEffect, useState } from 'react';
import { CustomModal } from '../CustomModal';
import { Btn } from '../ui';

export type UnlinkConsumableTarget = {
    linkId: string;
    itemName: string;
    procedureName: string;
};

interface DeleteServiceProcedureConsumableModalProps {
    target: UnlinkConsumableTarget | null;
    isRemoving: boolean;
    onDismiss: () => void;
    onConfirmRemove: () => void;
}

export const DeleteServiceProcedureConsumableModal = ({
    target,
    isRemoving,
    onDismiss,
    onConfirmRemove,
}: DeleteServiceProcedureConsumableModalProps) => {
    const visible = Boolean(target?.linkId);
    const [confirmReady, setConfirmReady] = useState(false);

    useEffect(() => {
        if (!visible) {
            setConfirmReady(false);
            return;
        }
        setConfirmReady(false);
        const timer = window.setTimeout(() => setConfirmReady(true), 400);
        return () => window.clearTimeout(timer);
    }, [visible, target?.linkId]);

    const itemName = target?.itemName?.trim() || 'this service item';
    const procedureName = target?.procedureName?.trim() || 'this procedure';

    return (
        <CustomModal
            onDismiss={onDismiss}
            visible={visible}
            header="Remove consumable?"
            footer={
                <div className="modal-footer-actions">
                    <Btn
                        variant="secondary-outlined"
                        buttonText="Cancel"
                        buttonDisabled={isRemoving}
                        buttonOnClick={onDismiss}
                    />
                    <Btn
                        variant="danger"
                        buttonText={isRemoving ? 'Removing...' : 'Remove'}
                        buttonDisabled={isRemoving || !confirmReady}
                        buttonOnClick={onConfirmRemove}
                    />
                </div>
            }
        >
            <p>
                You are about to unlink <strong>“{itemName}”</strong> from{' '}
                <strong>“{procedureName}”</strong>.
            </p>
            <p>The item stays on Service Items. Only this procedure link is removed.</p>
        </CustomModal>
    );
};
